/**
 * 日志打印
 */
export function error(msg, data) {
    console && console.error(`[gd-reporter error]: ${msg}`, data || '');
}
export function warn(msg, data) {
    console && console.warn(`[gd-reporter warn]: ${msg}`, data || '');
}
export function info(msg, data) {
    console && console.log(`[gd-reporter info]: ${msg}`, data || '');
}
